import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllProductCategories, getAllProducts } from "../../../api/action/products";
import CompanyDescription from "../Avikar-Template/components/companydetail";
import { RETAIL } from "../../s3-assets/Retail";
import serviceimage from "../Avikar-Template/components/drawing.png";
import { academyLogger } from "utils/logger";


function AvikarTemplate() {
    const [categoryProducts, setCategoryProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const company = useSelector((state) => state.companyReducer?.company || {});
    const companyPrimayId = company?.primaryId || localStorage.getItem("CompPrimaryId") || "";
    const contents = Array.isArray(company?.contents) ? company.contents : [];
    academyLogger.info("Company Contents:", contents);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                if (!companyPrimayId) {
                    setCategoryProducts([]);
                    return;
                }
                const response = await getAllProducts(companyPrimayId)(dispatch);
                setCategoryProducts(Array.isArray(response) ? response : []);
            } catch (error) {
                academyLogger.error("Error fetching products:", error);
            }
        };
        fetchProducts();
    }, [companyPrimayId, dispatch]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                if (!companyPrimayId) {
                    setCategories([]);
                    return;
                }
                const response = await getAllProductCategories(companyPrimayId)(dispatch);
                setCategories(Array.isArray(response) ? response : []);
            } catch (error) {
                academyLogger.error("Error fetching categories:", error);
            }
        };
        fetchCategories();
    }, [companyPrimayId, dispatch]);

    const heroContent = contents.find(
        (c) =>
            ["IMAGE", "VIDEO", "AUDIO"].includes(c.contentType) &&
            Array.isArray(c.tags) &&
            c.tags.some(tag => tag.name?.toLowerCase() === "hero section")
    );

    const normalizeCategoryValue = (value) => String(value || "").trim().toLowerCase();
    const categoryKeys = (category = {}) => [
        category.primaryId,
        category.id,
        category._id,
        category.code,
        category.name,
    ].map(normalizeCategoryValue).filter(Boolean);
    const isActiveProduct = (product = {}) => normalizeCategoryValue(product.status || "ACTIVE") === "active";

    const categoryKeysWithActiveProducts = new Set(
        categoryProducts
            .filter((product) => isActiveProduct(product) && product?.category)
            .flatMap((product) => categoryKeys(product.category))
    );

    const categoriesWithProducts = categories.filter((category) =>
        categoryKeys(category).some((key) => categoryKeysWithActiveProducts.has(key))
    );

    return (
        <div className="px-2 sm:px-4 lg:px-8">
            {/* Carousel */}
            <div className="carousel-container relative overflow-hidden rounded-lg mb-6 sm:mb-8">
                {heroContent ? (
                    heroContent.contentType === "IMAGE" ? (
                        <img
                            src={heroContent.displayLink || heroContent.storedLink}
                            alt="Hero Content"
                            className="w-full h-auto object-cover"
                        />
                    ) : heroContent.contentType === "VIDEO" ? (
                        <video
                            controls
                            className="w-full h-auto object-cover rounded-lg"
                        >
                            <source src={heroContent.displayLink || heroContent.storedLink} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    ) : heroContent.contentType === "AUDIO" ? (
                        <div className="flex items-center justify-center bg-gray-100 p-4 rounded-lg">
                            <audio controls className="w-full">
                                <source src={heroContent.displayLink || heroContent.storedLink} type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                    ) : null
                ) : (
                    <img
                        src={RETAIL.IMAGES.IMAGE_3}
                        alt="Fallback"
                        className="w-full h-auto object-cover"
                    />
                )}
            </div>

            <div className=" px-2 sm:px-4 lg:px-8">
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800 font-serif">
                    Shop by Category
                </h2>

                <p className="text-lg text-gray-600 mb-6 font-serif">
                    Collections of our most in-demand styles
                </p>

                <div className="flex space-x-4 overflow-x-auto scrollbar-hide max-w-full px-2">
                    {categoriesWithProducts.map((category, index) => (
                        <div
                            key={index}
                            className="relative flex-shrink-0 overflow-hidden rounded-lg shadow-md cursor-pointer w-72 h-[28rem]"
                            onClick={() =>
                                navigate(`/category/${category.name}`, {
                                    state: { name: category.name },
                                })
                            }
                        >
                            <img
                                loading="lazy"
                                src={category.imageContent?.displayLink || category.imageURL || RETAIL.IMAGES.IMAGE_3}
                                alt={category.name}
                                className="w-full h-full object-cover rounded-lg"
                                onError={(e) => {
                                    if (category.imageContent?.displayLink && category.imageURL) {
                                        e.target.src = category.imageURL;
                                    }
                                }}
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300 ease-in-out">
                                <h3 className="text-xl font-bold text-white">{category.name}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="carousel-container relative overflow-hidden rounded-lg mb-6 sm:mb-8">
                <div className="mb-6"></div>
                <img
                    src={RETAIL.IMAGES.IMAGE_1}
                    alt="Fashion Collection"
                    className="w-full max-h-[800px] object-cover"
                />
                <div className="absolute bottom-28 left-16 sm:bottom-16 sm:left-16 md:left-20">
                    <button
                        className="bg-white text-black px-6 py-2 rounded-lg shadow hover:bg-blue-700 text-sm sm:text-base md:text-lg"
                        onClick={() => navigate("/sign-in")}
                    >
                        Sign up
                    </button>
                </div>
            </div>

            <CompanyDescription />

            <div className="carousel-container relative overflow-hidden rounded-lg mb-6 sm:mb-8">

                <div className="mb-6"></div>
                {/* Replacing IMAGE_2 with serviceimage */}
                <img
                    src={serviceimage}
                    alt="Fashion Collection"
                    className="w-full max-h-[800px] object-cover"
                />


            </div>


        </div>
    );
}

export default AvikarTemplate;
